import {
  ADMIN_TYPE_ID,
  DEV_TYPE_ID,
  SUBCONTRACTOR_TYPE_ID,
  TRANSPORT_MANAGER_TYPE_ID,
  RADO_COORDINATOR_TYPE_ID,
  RBS_COORDINATOR_TYPE_ID
} from './constants/authConstants';

// login
export const LOGIN_ACCESS_USER_TYPES = [
  ADMIN_TYPE_ID,
  DEV_TYPE_ID,
  TRANSPORT_MANAGER_TYPE_ID,
  SUBCONTRACTOR_TYPE_ID,
  RADO_COORDINATOR_TYPE_ID,
  RBS_COORDINATOR_TYPE_ID
];

// actions map
export const COORDS_DIFFERENCE_METERS_WARNING_THRESHOLD = 10;
export const DEVICE_LOCATION_SHOW_MIN_DIFFERENCE_METERS = 1;
export const DEVICE_LOCATION_CONNECTION_LINE_COLOR = '#00000077';
export const ACTION_PHOTO_BASIC_CONNECTION_LINE_COLOR = '#ff8000'; // orange
export const ACTION_PHOTO_METADATA_CONNECTION_LINE_COLOR = '#cc2900'; // red

export const DASHBOARD_GENERAL_STATS_COLORS_BY_ELEM_TYPE_ID = [
  { id: 1, color: '#EDC240' },
  { id: 2, color: '#AFD8F8' },
  { id: 3, color: '#CB4B4B' },
  { id: 4, color: '#4DA74D' },
  { id: 5, color: '#9440ED' },
  { id: 6, color: '#FC5E03' },
  { id: 7, color: '#FC0377' },
  { id: 8, color: '#0307FC' }
];

export const ORDERS_MAP_PAGINATION = 1000;
export const TRANSPORT_ORDERS_MAP_PAGINATION = 4000;

export const DEFAULT_CLIENT_FOR_NEW_ORDER = {
  id: 1,
  name: 'OPL'
};
